import script from "./AttributeFormDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AttributeFormDialog.vue?vue&type=script&setup=true&lang=js"

import "./AttributeFormDialog.vue?vue&type=style&index=0&id=1ecb55a2&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ecb55a2"]])

export default __exports__